import React from 'react'
import { Text } from '@nike/eds'
import { Section } from '../components/Section.js'
import config from '../config.js'

const highlight = {
  fontWeight: 'bold',
  color: '#EE0005' // EDS Brand Red
}

const slackURL = `slack://channel?team=${config.slack.teamId}&id=${config.slack.channelId}`

const ClientSelector = () => (
  <Section title='What is this?'>
    <Text>
      This site is designed to help developers test out their oAuth applications by providing an
      easy way to generate test tokens. Select an environment to generate a token for, copy it, and
      test out the API calls you need to make.{' '}
      <span style={highlight}>
        You should not attempt to get tokens from this site to use in a production application.
      </span>
    </Text>
    <Text className='eds-spacing--mt-16'>
      {'For information on working with oAuth applications see the'}{' '}
      <a
        href='https://console.platforms.nike.com/developer/guide/apps'
        rel='noopener noreferrer'
        target='_blank'
        className='eds-link'
      >
        Developer Portal Guide
      </a>
      {'.'}
    </Text>
    <Text className='eds-spacing--mt-16'>
      {'For more questions and/or support, please reach out to our '}{' '}
      <a href={slackURL} rel='noopener noreferrer' target='_blank' className='eds-link'>
        Slack channel
      </a>
      {'.'}
    </Text>
  </Section>
)

export default ClientSelector
